import { ActionIcon, Menu, UnstyledButton, rem } from '@mantine/core';

import { IconDots } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const ActionsColumn = ({ row: { original: rowData } }) => {
    const routes = [
        {
            text: 'Details',
            path: `/devices/${rowData.id}/details`,
        },
    ];
    return (
        <Menu disabled={false}>
            <Menu.Target>
                <ActionIcon
                    color={'dimmed'}
                    variant='transparent'
                    disabled={false}>
                    <IconDots stroke={1.5} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {routes.map((x, i) => (
                    <Menu.Item
                        key={i}
                        component={Link}
                        to={x.path}>
                        {x.text}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
};
export default ActionsColumn;
